/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiIsReScreeningEnabledEvent
 */
export interface InternalApiIsReScreeningEnabledEvent {
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiIsReScreeningEnabledEvent
     */
    isReScreeningEnabled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiIsReScreeningEnabledEvent
     */
    createdTime: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiIsReScreeningEnabledEvent
     */
    createdBy?: InternalApiUserBasicDetails;
}

/**
 * Check if a given object implements the InternalApiIsReScreeningEnabledEvent interface.
 */
export function instanceOfInternalApiIsReScreeningEnabledEvent(value: object): value is InternalApiIsReScreeningEnabledEvent {
    if (!('isReScreeningEnabled' in value) || value['isReScreeningEnabled'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiIsReScreeningEnabledEventFromJSON(json: any): InternalApiIsReScreeningEnabledEvent {
    return InternalApiIsReScreeningEnabledEventFromJSONTyped(json, false);
}

export function InternalApiIsReScreeningEnabledEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiIsReScreeningEnabledEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'isReScreeningEnabled': json['isReScreeningEnabled'],
        'createdTime': (new Date(json['createdTime'])),
        'createdBy': json['createdBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['createdBy']),
    };
}

export function InternalApiIsReScreeningEnabledEventToJSON(json: any): InternalApiIsReScreeningEnabledEvent {
    return InternalApiIsReScreeningEnabledEventToJSONTyped(json, false);
}

export function InternalApiIsReScreeningEnabledEventToJSONTyped(value?: InternalApiIsReScreeningEnabledEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isReScreeningEnabled': value['isReScreeningEnabled'],
        'createdTime': value['createdTime'].toISOString(),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
    };
}

